<div *ngIf="isShown" class="cookie__banner border-top bg-color-ebony-a03-hue">
  <p class="cookie__banner--message l_flexbar">
    <df-icon
      icon="exclamation-circle"
      size="medium"
      class="color-blue"
    ></df-icon>
    <span [innerHTML]="trustedMessage" class="guts-m-l-1 l_flex-grow"></span>
    <button
      class="guts-m-l-1 l_flex-none"
      df-button
      df-button-small
      dfButtonType="primary"
      (click)="setSessionCookie()"
      data-dgat="cookieBanner-124"
    >
      {{ acceptCookies }}
    </button>
  </p>
</div>
